import { debounceCallback } from "@caprikorn/dynamo-utils";
import { useQuery } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type { GetCustomers, GetCustomersParams } from "./apiEcms.types";

const getCustomers = async (
  { search, pageNumber }: GetCustomersParams,
  signal: AbortSignal,
) => {
  const { data } = await apiEcmsHttp.get<GetCustomers>("/customers", {
    params: {
      pageNumber,
      q: search,
    },
    signal,
  });

  return data;
};

const debouncedGetCustomers = debounceCallback(getCustomers);

export const useGetCustomers = (pageNumber: number, search?: string) => {
  const { currentGroup } = useGroupReferences();

  return useQuery({
    queryKey: [
      QUERY_KEYS.PERIMETER_DATA,
      QUERY_KEYS.PERIMETER_CUSTOMERS_DATA,
      pageNumber,
      search,
      currentGroup,
    ],
    queryFn: ({ signal }) =>
      debouncedGetCustomers({ pageNumber, search }, signal),
  });
};
